export default "__VITE_ASSET__CjnvTrXH__"